import { render, staticRenderFns } from "./EventDelivery.vue?vue&type=template&id=24a81fe4&scoped=true&"
import script from "./EventDelivery.vue?vue&type=script&lang=js&"
export * from "./EventDelivery.vue?vue&type=script&lang=js&"
import style0 from "./EventDelivery.vue?vue&type=style&index=0&id=24a81fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a81fe4",
  null
  
)

export default component.exports